import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { BIO, BIO_PULLQUOTE, NANCY_VIDEO } from "../../data";

const ease = [0.22, 1, 0.36, 1];

export const Manifesto = ({ hideHeading = false, mediaImg = null }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-30, 40]);

  return (
    <section id="manifesto" ref={ref} className="py-24 md:py-40 bg-stone" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-5 md:sticky md:top-32 h-fit">
          {!hideHeading && (
            <>
              <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-6">Designer & Founder</p>
              <h2 className="font-serif font-light text-5xl md:text-6xl leading-[0.95] tracking-tight mb-10">
                Meet Nancy
              </h2>
            </>
          )}
          <motion.div style={{ y }} className="relative overflow-hidden aspect-[4/5] border border-line">
            {mediaImg ? (
              <img src={mediaImg} alt="Nancy at work" className="w-full h-full object-cover object-center" />
            ) : (
              <video
                src={NANCY_VIDEO}
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
                data-testid="nancy-video"
              />
            )}
          </motion.div>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <div className="space-y-8 md:space-y-10">
            {BIO.map((para, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease }}
                className={`font-light leading-relaxed ${
                  i === 0 ? "text-xl md:text-2xl text-ink/90 font-serif" : "text-base md:text-lg text-ink/70"
                }`}
              >
                {para}
              </motion.p>
            ))}
          </div>

          <motion.blockquote
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease }}
            className="mt-14 md:mt-20 border-t border-line pt-10"
          >
            <p className="font-serif italic text-3xl md:text-5xl leading-[1.1] tracking-tight">
              “{BIO_PULLQUOTE}”
            </p>
            <footer className="mt-6 text-xs uppercase tracking-[0.3em] text-ink/50">
              Nancy Khau · Designer & Founder
            </footer>
          </motion.blockquote>
        </div>
      </div>
    </section>
  );
};
